/* MNSH Modern Cart Drawer
 * Vanilla JS — no jQuery dependency.
 * Handles:
 *   1. Total breakdown caret toggle
 *   2. Tier-unlock detection on cart change → confetti burst
 *   3. Live progress bar + heading update after cart:added/cart:update
 *   4. "+ ADD" buttons on recommendations
 *
 * Hooks into the existing theme's cart events:
 *   - 'theme:cart:added'   (theme.dev.js dispatches after add)
 *   - 'theme:cart:update'  (quantity-counter.js dispatches)
 *   - 'theme:cart-drawer:open' (cart-drawer custom element)
 */
(function () {
  'use strict';

  if (window.MNSHCartModern) return;
  window.MNSHCartModern = true;

  var SELECTORS = {
    drawer: '.cart-drawer--modern',
    tierStep: '.mnsh-tier__step',
    tierFill: '.mnsh-tier__fill',
    tierHeading: '.mnsh-tier__heading',
    totalToggle: '[data-mnsh-total-toggle]',
    totalBreakdown: '[data-mnsh-total-breakdown]',
    recAdd: '[data-mnsh-rec-add]',
    pillRemove: '[data-mnsh-pill-remove]',
    pillApply: '[data-mnsh-pill-apply]',
    pills: '[data-mnsh-pills]',
    drawerCartCount: 'cart-count.cart__items-count'
  };

  /* 1–9 → 01…09; 10+ → 10, 11, … (theme CartCount.update uses raw number). */
  function formatDrawerCartCount(count) {
    var n = parseInt(count, 10);
    if (isNaN(n) || n < 0) return '00';
    if (n >= 10) return String(n);
    return ('0' + n).slice(-2);
  }

  function syncDrawerCartCounts(drawer) {
    if (!drawer) drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;
    drawer.querySelectorAll(SELECTORS.drawerCartCount).forEach(function (el) {
      var raw = el.getAttribute('data-cart-count');
      if (raw == null) return;
      el.textContent = formatDrawerCartCount(raw);
    });
  }

  function patchCartCountForModernDrawer() {
    if (patchCartCountForModernDrawer._done) return;
    var CartCountEl = customElements.get('cart-count');
    if (!CartCountEl || !CartCountEl.prototype || !CartCountEl.prototype.update) return;
    var originalUpdate = CartCountEl.prototype.update;
    CartCountEl.prototype.update = function () {
      originalUpdate.call(this);
      if (!this.closest || !this.closest(SELECTORS.drawer)) return;
      if (this.limit && parseInt(this.cartCount, 10) >= parseInt(this.limit, 10)) return;
      var raw = this.getAttribute('data-cart-count');
      if (raw != null) this.textContent = formatDrawerCartCount(raw);
    };
    patchCartCountForModernDrawer._done = true;
  }

  patchCartCountForModernDrawer();

  /* Theme CartItems.build() replaces [data-cart-total] innerHTML after each
     cart change. In modern markup that node is visually-hidden; sync the
     visible amount and re-bind the caret after every build(). */
  function stripTrailingZeroDecimals(formatted) {
    if (window.theme && typeof window.theme.stripTrailingZeroDecimals === 'function') {
      return window.theme.stripTrailingZeroDecimals(formatted);
    }
    if (typeof formatted !== 'string') return formatted;
    return formatted.replace(/\.00$/, '');
  }

  function moneyFormatToPlainText(formatted) {
    if (window.theme && typeof window.theme.moneyFormatToPlainText === 'function') {
      return window.theme.moneyFormatToPlainText(formatted);
    }
    if (typeof formatted !== 'string') return formatted;
    if (formatted.indexOf('<') === -1) return formatted;
    var el = document.createElement('div');
    el.innerHTML = formatted;
    return (el.textContent || el.innerText || '').trim();
  }

  function syncModernCartTotalDisplay(drawer) {
    if (!drawer) drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;
    var holder = drawer.querySelector('[data-cart-price-holder]');
    if (!holder) return;
    var hiddenTotal = holder.querySelector('[data-cart-total]');
    var amountEl = holder.querySelector('[data-mnsh-cart-amount]');
    if (!amountEl) return;
    var cents = parseInt(
      (amountEl.getAttribute('data-mnsh-cents') || (hiddenTotal && hiddenTotal.getAttribute('data-cart-total')) || '0'),
      10
    );
    var nextText = formatDrawerMoneyFromCents(cents);
    if (amountEl.textContent !== nextText) {
      amountEl.textContent = nextText;
    }
    amountEl.setAttribute('data-mnsh-cents', String(cents));
  }

  function formatDrawerMoneyFromCents(cents) {
    var amount = parseInt(cents, 10) || 0;
    if (amount === 0) {
      return (window.theme && window.theme.strings && window.theme.strings.free) ? window.theme.strings.free : 'FREE';
    }
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      var fmt = window.theme.moneyWithCurrencyFormat || window.theme.moneyFormat;
      return stripTrailingZeroDecimals(
        moneyFormatToPlainText(window.theme.formatMoney(amount, fmt))
      );
    }
    return 'Rs. ' + String(Math.round(amount / 100));
  }

  function syncDrawerBreakdownMoney(drawer) {
    if (!drawer) drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;
    drawer.querySelectorAll('.mnsh-money[data-mnsh-cents]').forEach(function (el) {
      var cents = parseInt(el.getAttribute('data-mnsh-cents') || '0', 10);
      var formatted = formatDrawerMoneyFromCents(cents);
      var nextText = el.getAttribute('data-mnsh-prefix') === 'minus'
        ? '\u2212 ' + formatted
        : formatted;
      if (el.textContent !== nextText) {
        el.textContent = nextText;
      }
    });
    syncModernCartTotalDisplay(drawer);
  }

  function normalizeDrawerLinePrices(drawer) {
    if (!drawer) drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;

    drawer.querySelectorAll('.mnsh-cart-price').forEach(function (row) {
      var finalCents = parseInt(row.getAttribute('data-mnsh-final-cents') || '0', 10);
      var compareCents = parseInt(row.getAttribute('data-mnsh-compare-cents') || '0', 10);
      var savePercent = parseInt(row.getAttribute('data-mnsh-save-percent') || '0', 10);

      var targetTextSig = String(finalCents) + '|' + String(compareCents) + '|' + String(savePercent);
      if (row.dataset.mnshSig === targetTextSig && row.querySelector('ins')) return;

      var html = '<ins>' + formatDrawerMoneyFromCents(finalCents) + '</ins>';
      if (compareCents > finalCents) {
        html += '<del>' + formatDrawerMoneyFromCents(compareCents) + '</del>';
      }
      if (savePercent > 0) {
        html += '<span class="mnsh-save-pill">SAVE ' + savePercent + '%</span>';
      }

      row.innerHTML = html;
      row.dataset.mnshSig = targetTextSig;
    });
  }

  function armDrawerPriceGuard(drawer) {
    if (!drawer || drawer.dataset.mnshPriceGuard === '1') return;
    drawer.dataset.mnshPriceGuard = '1';

    var queued = false;
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        normalizeDrawerLinePrices(drawer);
        syncDrawerBreakdownMoney(drawer);
      });
    }

    normalizeDrawerLinePrices(drawer);
    syncDrawerBreakdownMoney(drawer);

    var itemsHolder = drawer.querySelector('[data-items-holder]');
    var priceHolder = drawer.querySelector('[data-cart-price-holder]');
    var observer = new MutationObserver(queue);
    if (itemsHolder) observer.observe(itemsHolder, { childList: true, subtree: true, characterData: true });
    if (priceHolder) observer.observe(priceHolder, { childList: true, subtree: true, characterData: true });
  }

  function patchCartItemsBuildForModernDrawer() {
    if (patchCartItemsBuildForModernDrawer._done) return;
    var CartItemsEl = customElements.get('cart-items');
    if (!CartItemsEl || !CartItemsEl.prototype || !CartItemsEl.prototype.build) return;
    var originalBuild = CartItemsEl.prototype.build;
    var originalConnected = CartItemsEl.prototype.connectedCallback;
    CartItemsEl.prototype.connectedCallback = function () {
      if (typeof originalConnected === 'function') originalConnected.call(this);
      var drawer = document.querySelector(SELECTORS.drawer);
      if (drawer) {
        var hidden = drawer.querySelector('[data-cart-price-holder] [data-cart-total]');
        if (hidden) this.cartTotal = hidden;
      }
    };
    CartItemsEl.prototype.build = function (data) {
      var drawer = document.querySelector(SELECTORS.drawer);
      originalBuild.call(this, data);
      if (!drawer) return;
      var hidden = drawer.querySelector('[data-cart-price-holder] [data-cart-total]');
      if (hidden) {
        this.cartTotal = hidden;
        if (typeof this.subtotal === 'number') {
          hidden.setAttribute('data-cart-total', String(this.subtotal));
          var amountEl = drawer.querySelector('[data-mnsh-cart-amount]');
          if (amountEl) amountEl.setAttribute('data-mnsh-cents', String(this.subtotal));
        }
      }
      syncModernCartTotalDisplay(drawer);
      syncDrawerBreakdownMoney(drawer);
      normalizeDrawerLinePrices(drawer);
      ensureTotalToggleVisible(drawer);
      bindTotalToggle(drawer);
      loadRecommendations(drawer);
    };
    patchCartItemsBuildForModernDrawer._done = true;
  }

  function patchCartItemsBuildForModernDrawerRetry(attempt) {
    attempt = attempt || 0;
    patchCartItemsBuildForModernDrawer();
    if (!patchCartItemsBuildForModernDrawer._done && attempt < 40) {
      setTimeout(function () {
        patchCartItemsBuildForModernDrawerRetry(attempt + 1);
      }, 50);
    }
  }

  patchCartItemsBuildForModernDrawerRetry(0);

  /* ------------------------------------------------------------------ */
  /* Confetti                                                            */
  /* ------------------------------------------------------------------ */
  function launchConfetti(originEl) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'mnsh-confetti-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');

    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    var rect = originEl ? originEl.getBoundingClientRect() : { left: window.innerWidth - 200, top: 200, width: 0, height: 0 };
    var originX = rect.left + rect.width / 2;
    var originY = rect.top + rect.height / 2;

    var colors = ['#C8941A', '#E6A455', '#F5E0A6', '#FFFFFF', '#0F0F0F'];
    var particles = [];
    var count = 72;
    var duration = 2800;
    for (var i = 0; i < count; i++) {
      var angle = (Math.random() * 0.85 + 0.075) * Math.PI;
      var speed = 5 + Math.random() * 9;
      particles.push({
        x: originX,
        y: originY,
        vx: Math.cos(angle) * speed * (Math.random() > 0.5 ? 1 : -1),
        vy: -Math.sin(angle) * speed - Math.random() * 3,
        size: 3 + Math.random() * 4,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * Math.PI * 2,
        vr: (Math.random() - 0.5) * 0.16,
        gravity: 0.22 + Math.random() * 0.12,
        drag: 0.985 + Math.random() * 0.01,
        life: 1
      });
    }

    var start = performance.now();
    function frame(t) {
      var elapsed = t - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        p.vx *= p.drag;
        p.vy *= p.drag;
        p.vy += p.gravity;
        p.rotation += p.vr;
        var lifeT = elapsed / duration;
        p.life = lifeT >= 1 ? 0 : 1 - lifeT * lifeT;
        if (p.life <= 0) return;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.globalAlpha = p.life;
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 1.35);
        ctx.restore();
      });
      if (elapsed < duration + 120) {
        requestAnimationFrame(frame);
      } else {
        canvas.remove();
        window.removeEventListener('resize', resize);
      }
    }
    requestAnimationFrame(frame);
  }

  /* ------------------------------------------------------------------ */
  /* Tier-unlock detection                                               */
  /* ------------------------------------------------------------------ */
  var lastUnlockedTier = -1;

  function activeStepThresholds(drawer) {
    var stepEls = drawer.querySelectorAll(SELECTORS.tierStep);
    return Array.prototype.map.call(stepEls, function (el) {
      return parseFloat(el.getAttribute('data-threshold') || '0');
    });
  }

  function currentUnlockedTier(total, thresholds) {
    for (var i = thresholds.length - 1; i >= 0; i--) {
      if (thresholds[i] > 0 && total >= thresholds[i]) return i;
    }
    return -1;
  }

  function syncProgress(drawer, total, depth) {
    if (typeof depth === 'undefined') depth = 0;
    /* Each rendered step carries:
         data-threshold  → the tier's rupee threshold
         data-position   → the tier's slot position on the bar (% of bar)
       Slot positions come from snippets/cart-tiered-progress.liquid:
         1 tier  → [90]
         2 tiers → [50, 90]
         3 tiers → [10, 50, 90]
       Keep this in lock-step with the Liquid snippet. */
    var stepEls = Array.prototype.slice.call(drawer.querySelectorAll(SELECTORS.tierStep));
    if (stepEls.length === 0) return;

    var activeThresholds = stepEls.map(function (el) {
      return parseFloat(el.getAttribute('data-threshold') || '0');
    });
    var positions = stepEls.map(function (el) {
      return parseFloat(el.getAttribute('data-position') || '0');
    });
    var activeLabels = stepEls.map(function (el) {
      var labelEl = el.querySelector('.mnsh-tier__label');
      return labelEl ? labelEl.textContent.trim() : '';
    });
    var count = activeThresholds.length;

    var showAmountsAttr = drawer && drawer.getAttribute('data-mnsh-tier-show-amounts');
    var textMode = showAmountsAttr === 'false';

    /* Find the next locked tier (for heading + step state + fill segment). */
    var nextIdx = -1;
    for (var i = 0; i < count; i++) {
      if (total < activeThresholds[i]) {
        nextIdx = i;
        break;
      }
    }

    /* Trimmed-line fill — progress is a % WITHIN the line, which is
       drawn from the FIRST milestone center to the LAST milestone
       center (see CSS .mnsh-tier__line `left: var(--mnsh-line-start)`).
       So the math collapses to: equal segments between adjacent
       milestones, where cart < first threshold means 0% (milestone 1
       grey, no fill), and cart >= last threshold means 100%. */
    var percent;
    if (textMode && total > 0) {
      percent = 100;
      nextIdx = -1;
    } else if (count <= 1) {
      percent = 0;
    } else if (nextIdx === -1) {
      percent = 100;
    } else if (nextIdx === 0) {
      percent = 0;
    } else {
      var segIdx = nextIdx - 1;
      var segCount = count - 1;
      var segSize = 100 / segCount;
      var segStart = segIdx * segSize;
      var thFromSeg = activeThresholds[segIdx];
      var thToSeg = activeThresholds[segIdx + 1];
      var moneySpan = thToSeg - thFromSeg;
      if (moneySpan > 0) {
        var moneyDone = Math.max(0, total - thFromSeg);
        percent = segStart + (moneyDone * segSize) / moneySpan;
      } else {
        percent = segStart;
      }
    }
    if (percent > 100) percent = 100;
    if (percent < 0) percent = 0;

    var fill = drawer.querySelector(SELECTORS.tierFill);
    if (fill) fill.style.setProperty('--mnsh-progress', percent.toFixed(2) + '%');

    /* Update step states */
    stepEls.forEach(function (step, idx) {
      var threshold = activeThresholds[idx];
      var unlocked = threshold > 0 && total >= threshold;
      var current = !unlocked && idx === nextIdx;

      if (textMode && total > 0) {
        unlocked = true;
        current = false;
      }

      step.classList.toggle('is-unlocked', unlocked);
      step.classList.toggle('is-current', current);
    });

    /* Update header text */
    var heading = drawer.querySelector(SELECTORS.tierHeading);
    if (heading) {
      if (!tierHeadingEnabled(drawer)) {
        heading.hidden = true;
      } else {
        heading.hidden = false;
        if (nextIdx === -1) {
          heading.innerHTML = '<span class="mnsh-tier__heading-spark">\u2728</span> All rewards unlocked! <span class="mnsh-tier__heading-spark">\u2728</span>';
        } else {
          var nextLabel = activeLabels[nextIdx] || '';
          var remaining = activeThresholds[nextIdx] - total;
          var currency = drawer.getAttribute('data-currency-symbol') || '\u20b9';
          heading.innerHTML =
            '<span class="mnsh-tier__heading-spark">\u2726</span> ADD ' +
            '<span class="mnsh-tier__heading-highlight">' + currency + Math.ceil(remaining) + ' MORE</span>' +
            ' TO <span class="mnsh-tier__heading-highlight">UNLOCK ' + nextLabel + '</span> ON YOUR ORDER ' +
            '<span class="mnsh-tier__heading-spark">\u2726</span>';
        }
      }
    }

    /* Confetti on tier unlock */
    var newlyUnlocked = -1;
    for (var j = count - 1; j >= 0; j--) {
      if (activeThresholds[j] > 0 && total >= activeThresholds[j]) {
        newlyUnlocked = j;
        break;
      }
    }
    if (newlyUnlocked > lastUnlockedTier && total > 0) {
      var stepEl = drawer.querySelector('.mnsh-tier__step[data-tier-index="' + newlyUnlocked + '"] .mnsh-tier__icon-wrap');
      launchConfetti(stepEl);
    }
    lastUnlockedTier = newlyUnlocked;
  }

  /* ------------------------------------------------------------------ */
  /* Total breakdown caret (persistent — outside data-cart-price-holder) */
  /* ------------------------------------------------------------------ */
  function getPersistedTotalToggle(drawer) {
    return drawer.querySelector('[data-mnsh-total-toggle-persist]')
      || drawer.querySelector('.mnsh-total__wrap > ' + SELECTORS.totalToggle);
  }

  function bindTotalToggleDelegation(drawer) {
    if (!drawer || drawer.dataset.mnshToggleDelegated === '1') return;
    drawer.dataset.mnshToggleDelegated = '1';
    drawer.addEventListener('click', function (e) {
      var toggle = e.target.closest && e.target.closest('[data-mnsh-total-toggle]');
      if (!toggle || !drawer.contains(toggle)) return;
      var breakdown = drawer.querySelector(SELECTORS.totalBreakdown);
      if (!breakdown) return;
      e.preventDefault();
      var open = toggle.classList.toggle('is-open');
      breakdown.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function bindTotalToggle(drawer) {
    bindTotalToggleDelegation(drawer);
  }

  function ensureTotalToggleVisible(drawer) {
    if (!drawer) drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;
    var wrap = drawer.querySelector('.mnsh-total__wrap');
    if (!wrap) return;
    if (getPersistedTotalToggle(drawer)) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mnsh-total__toggle';
    btn.setAttribute('data-mnsh-total-toggle', '');
    btn.setAttribute('data-mnsh-total-toggle-persist', '');
    btn.setAttribute('aria-label', 'Show price breakdown');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-nav-arrow-down" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    wrap.appendChild(btn);
  }

  /* ------------------------------------------------------------------ */
  /* Recommendations (You may also like)                                 */
  /* ------------------------------------------------------------------ */
  function recMoney(cents) {
    return '\u20b9' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function renderRecommendations(scroll, products) {
    scroll.innerHTML = '';
    products.slice(0, 8).forEach(function (p) {
      if (!p) return;
      var card = document.createElement('div');
      card.className = 'mnsh-recs__card';

      var imgUrl = p.featured_image
        ? (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.url || p.featured_image.src)
        : (p.media && p.media[0] && p.media[0].preview_image ? p.media[0].preview_image.src : '');

      var defaultVariantId = (p.variants && p.variants[0]) ? p.variants[0].id : '';
      var price = (p.price != null) ? p.price : (p.variants && p.variants[0] ? p.variants[0].price : 0);
      var priceCents = typeof price === 'string' ? parseFloat(price) * 100 : price;

      card.innerHTML =
        '<a class="mnsh-recs__image" href="' + (p.url || '#') + '">' +
          (imgUrl ? '<img src="' + imgUrl + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy"/>' : '') +
        '</a>' +
        '<div class="mnsh-recs__info">' +
          '<h5 class="mnsh-recs__title"><a href="' + (p.url || '#') + '">' + (p.title || '') + '</a></h5>' +
          '<div class="mnsh-recs__price-row">' +
            '<span class="mnsh-recs__price">' + recMoney(priceCents) + '</span>' +
            '<button type="button" class="mnsh-recs__add" data-mnsh-rec-add data-variant-id="' + defaultVariantId + '">+ ADD</button>' +
          '</div>' +
        '</div>';

      scroll.appendChild(card);
    });
  }

  function resolveRecsProductId(drawer, container) {
    var id = container.getAttribute('data-product-id');
    if (id) return id;
    if (!drawer) return null;
    var item = drawer.querySelector('[data-items-holder] .cart__item[data-product-id]');
    if (!item) return null;
    id = item.getAttribute('data-product-id');
    if (id) container.setAttribute('data-product-id', id);
    return id;
  }

  function syncRecsContainer(drawer) {
    if (!drawer) drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;
    var container = drawer.querySelector('[data-mnsh-recs]');
    if (!container) return;
    var productId = resolveRecsProductId(drawer, container);
    if (!productId) {
      container.classList.add('mnsh-recs--pending');
      container.removeAttribute('data-product-id');
      delete container.dataset.mnshLoaded;
      delete container.dataset.mnshRecsFor;
      return;
    }
    container.classList.remove('mnsh-recs--pending');
    if (container.dataset.mnshRecsFor && container.dataset.mnshRecsFor !== String(productId)) {
      delete container.dataset.mnshLoaded;
      var scroll = container.querySelector('[data-mnsh-recs-scroll]');
      if (scroll) scroll.innerHTML = '';
    }
    container.setAttribute('data-product-id', productId);
  }

  var recsFetchToken = 0;
  function loadRecommendations(drawer) {
    if (!drawer) drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;
    var container = drawer.querySelector('[data-mnsh-recs]');
    if (!container) return;

    syncRecsContainer(drawer);
    var productId = resolveRecsProductId(drawer, container);
    if (!productId) return;

    if (container.dataset.mnshLoaded === '1' && container.dataset.mnshRecsFor === String(productId)) {
      bindRecAdd(drawer);
      return;
    }

    var scroll = container.querySelector('[data-mnsh-recs-scroll]');
    if (!scroll) return;

    var token = ++recsFetchToken;
    var url = '/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related';
    fetch(url, { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (token !== recsFetchToken) return;
        var products = data.products || [];
        if (products.length === 0) {
          container.classList.add('mnsh-recs--pending');
          return;
        }
        container.classList.remove('mnsh-recs--pending');
        renderRecommendations(scroll, products);
        container.dataset.mnshLoaded = '1';
        container.dataset.mnshRecsFor = String(productId);
        bindRecAdd(drawer);
      })
      .catch(function () {
        if (token !== recsFetchToken) return;
        container.classList.add('mnsh-recs--pending');
      });
  }

  /* ------------------------------------------------------------------ */
  /* + ADD on recommendations                                            */
  /* ------------------------------------------------------------------ */
  function bindRecAdd(drawer) {
    drawer.querySelectorAll(SELECTORS.recAdd).forEach(function (btn) {
      if (btn.dataset.mnshBound === '1') return;
      btn.dataset.mnshBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = 'Adding\u2026';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            /* Trigger the legacy CartItems flow: refetch the cart, rebuild
               itemsHolder + priceHolder, then dispatch theme:product:added
               which the CartDrawer listens to (auto-open). Our own
               theme:product:added listener will then sync the progress bar. */
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
            btn.textContent = 'ADDED';
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 1200);
          })
          .catch(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          });
      });
    });
  }

  function injectPillCustomSvgs(pillsRoot) {
    if (!pillsRoot) return;
    pillsRoot.querySelectorAll('script.mnsh-pill-svg-source[type="application/json"]').forEach(function (script) {
      var key = script.getAttribute('data-pill-key');
      if (!key) return;
      var pill = pillsRoot.querySelector('.mnsh-pill[data-mnsh-pill-key="' + key + '"]');
      if (!pill) return;
      var slot = pill.querySelector('[data-mnsh-pill-icon-slot="' + key + '"]');
      if (!slot) return;
      try {
        var svg = JSON.parse(script.textContent || 'null');
        if (typeof svg !== 'string' || !svg.trim()) return;
        slot.innerHTML = svg.trim();
      } catch (err) {}
    });
  }

  /* ------------------------------------------------------------------ */
  /* Pill APPLY CODE → copy discount code to clipboard                   */
  /* ------------------------------------------------------------------ */
  function bindPillApply(drawer) {
    var pillsRoot = drawer.querySelector(SELECTORS.pills);
    var copiedLabel = (pillsRoot && pillsRoot.getAttribute('data-pill-copied-label')) || 'Copied!';

    drawer.querySelectorAll(SELECTORS.pillApply).forEach(function (btn) {
      if (btn.dataset.mnshBoundApply === '1') return;
      btn.dataset.mnshBoundApply = '1';
      var defaultLabel = btn.textContent.trim();
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var text = (btn.getAttribute('data-clipboard-text') || '').trim();
        if (!text) return;

        function showCopied() {
          btn.textContent = copiedLabel;
          btn.disabled = true;
          setTimeout(function () {
            btn.textContent = defaultLabel;
            btn.disabled = false;
          }, 1600);
        }

        function fallbackCopy() {
          var ta = document.createElement('textarea');
          ta.value = text;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
            showCopied();
          } catch (err) {}
          document.body.removeChild(ta);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(showCopied).catch(fallbackCopy);
        } else {
          fallbackCopy();
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Pill REMOVE → clear discount                                        */
  /* ------------------------------------------------------------------ */
  function bindPillRemove(drawer) {
    drawer.querySelectorAll(SELECTORS.pillRemove).forEach(function (btn) {
      if (btn.dataset.mnshBound === '1') return;
      btn.dataset.mnshBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var pill = btn.closest('.mnsh-pill');
        if (pill) {
          pill.style.transition = 'opacity 0.2s ease';
          pill.style.opacity = '0';
          setTimeout(function () { pill.remove(); }, 200);
        }
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Init / re-init                                                      */
  /* ------------------------------------------------------------------ */
  function init() {
    patchCartItemsBuildForModernDrawerRetry();
    var drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;
    bindTotalToggleDelegation(drawer);

    var cartTotal = parseFloat(drawer.getAttribute('data-mnsh-cart-total') || '0');
    var thresholds = activeStepThresholds(drawer);
    lastUnlockedTier = currentUnlockedTier(cartTotal, thresholds);

    bindRecAdd(drawer);
    injectPillCustomSvgs(drawer.querySelector(SELECTORS.pills));
    bindPillApply(drawer);
    bindPillRemove(drawer);
    syncProgress(drawer, cartTotal);
    syncDrawerCartCounts(drawer);
    syncModernCartTotalDisplay(drawer);
    syncDrawerBreakdownMoney(drawer);
    normalizeDrawerLinePrices(drawer);
    armDrawerPriceGuard(drawer);
    ensureTotalToggleVisible(drawer);
    bindTotalToggle(drawer);

    /* DISABLED: Theme auto-added reward via /cart/add.js. Use Shopify
       Automatic discount (Buy X get Y) instead — see cart-drawer.liquid
       (reward data attrs commented) and cart-line-items / cart-price. */
  }

  /* .mnsh-reward is static prepaid copy from theme settings — no cart sync. */
  function syncRewardCard() {}

  /* ------------------------------------------------------------------ */
  /* DISABLED — was: /cart/add auto-gift, /cart/change remove,            */
  /* sessionStorage mnshRewardDismissed, getRewardCfg, syncRewardProduct. */
  /* Free line + cart total = Shopify discount (Buy X get Y / automatic). */
  /* Re-enable from git history if you need theme-side gift again.        */
  /* ------------------------------------------------------------------ */

  /* Instant refresh — reads the freshly-replaced subtotal straight from the
     cart-price markup (legacy CartItems.build() has already updated it).
     This avoids the latency of a second /cart.js round-trip. */
  function refreshFromDOM() {
    var drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer) return;
    var totalEl = drawer.querySelector('[data-cart-price-holder] [data-cart-total]');
    if (!totalEl) return;
    var subtotalCents = parseFloat(totalEl.getAttribute('data-cart-total') || '0');
    var subtotal = subtotalCents / 100;
    drawer.setAttribute('data-mnsh-cart-total', subtotal);
    syncProgress(drawer, subtotal);
    syncRewardCard(drawer, { total_price: subtotalCents });
    bindRecAdd(drawer);
    injectPillCustomSvgs(drawer.querySelector(SELECTORS.pills));
    bindPillApply(drawer);
    bindPillRemove(drawer);
    syncDrawerCartCounts(drawer);
    syncModernCartTotalDisplay(drawer);
    syncDrawerBreakdownMoney(drawer);
    normalizeDrawerLinePrices(drawer);
    ensureTotalToggleVisible(drawer);
    bindTotalToggle(drawer);
    loadRecommendations(drawer);

    /* DISABLED: was second /cart.js fetch for theme auto-gift (syncRewardProduct). */
  }

  function refreshFromCart(drawer, cart) {
    var total = cart.total_price / 100;
    drawer.setAttribute('data-mnsh-cart-total', total);
    syncProgress(drawer, total);
    syncRewardCard(drawer, cart);
    bindRecAdd(drawer);
    injectPillCustomSvgs(drawer.querySelector(SELECTORS.pills));
    bindPillApply(drawer);
    bindPillRemove(drawer);
    syncDrawerCartCounts(drawer);
    syncModernCartTotalDisplay(drawer);
    syncDrawerBreakdownMoney(drawer);
    normalizeDrawerLinePrices(drawer);
    ensureTotalToggleVisible(drawer);
    bindTotalToggle(drawer);
    if (cart && cart.items && cart.items[0] && cart.items[0].product_id) {
      var recs = drawer.querySelector('[data-mnsh-recs]');
      if (recs) recs.setAttribute('data-product-id', cart.items[0].product_id);
    }
    loadRecommendations(drawer);
  }

  /* Debounced async fallback for events that fire BEFORE the DOM has been
     re-rendered (e.g. third-party scripts that only announce a cart change). */
  var fetchTimer = null;
  var fetchPending = false;
  function fetchAndRefresh() {
    if (fetchPending) return;
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () {
      var drawer = document.querySelector(SELECTORS.drawer);
      if (!drawer) return;
      fetchPending = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { refreshFromCart(drawer, cart); })
        .catch(function () {})
        .then(function () { fetchPending = false; });
    }, 60);
  }

  /* Listen to theme cart events.
     theme:cart:change and theme:product:added are dispatched DURING / right
     after CartItems.build() has already re-rendered the cart-price markup,
     so we can sync instantly from the DOM (no /cart.js round-trip).
     Other events (third-party / pre-DOM-render) fall back to fetch. */
  document.addEventListener('theme:cart:change', refreshFromDOM);
  document.addEventListener('theme:product:added', refreshFromDOM);

  document.addEventListener('theme:cart:added', function (e) {
    if (e.detail && e.detail.cart) {
      var drawer = document.querySelector(SELECTORS.drawer);
      if (drawer) refreshFromCart(drawer, e.detail.cart);
    } else {
      fetchAndRefresh();
    }
  });

  document.addEventListener('theme:cart:reload', fetchAndRefresh);

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) {
      var drawer = document.querySelector(SELECTORS.drawer);
      if (drawer) refreshFromCart(drawer, e.detail.cart);
    } else {
      fetchAndRefresh();
    }
  });

  /* ------------------------------------------------------------------ */
  /* Defensive add-to-cart capture                                       */
  /* ------------------------------------------------------------------ */
  /* Some product templates (e.g. `product.pre-order`, or pages where the
     <product-form> custom element fails to register / is overridden by a
     3rd-party app) end up submitting the form natively to /cart/add, which
     Shopify responds to with a redirect to the cart page. We intercept the
     submit at the capture phase, prevent the native POST, and re-route the
     add through the theme's existing AJAX flow (theme:cart:add → CartItems
     → drawer open). Works for default, pre-order, and any future templates
     without touching theme.dev.js. */
  function looksLikeCartAddForm(form) {
    if (!form || !(form instanceof HTMLFormElement)) return false;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return false;
    /* Only intercept POST submits to /cart/add — not search forms, etc. */
    var method = (form.getAttribute('method') || '').toLowerCase();
    if (method && method !== 'post') return false;
    return true;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!looksLikeCartAddForm(form)) return;
    /* If the click already went through the custom <product-form> path,
       the submit event won't fire (click handler calls preventDefault on
       the button click). Reaching here means native form submit \u2014 hijack. */
    e.preventDefault();
    e.stopPropagation();

    /* Locate the most useful "trigger button" so existing add-to-cart UX
       (loading state, error display) keeps working. */
    var button = form.querySelector('[data-add-to-cart]')
              || form.querySelector('button[name="add"]')
              || form.querySelector('button[type="submit"]')
              || document.activeElement;

    document.dispatchEvent(new CustomEvent('theme:cart:add', {
      detail: { button: button, form: form },
      bubbles: false
    }));
  }, true);

  /* Extra safety net: also catch Enter-key presses inside the qty/variant
     inputs that browsers translate into form submit. The submit listener
     above already handles them, but if a 3rd-party app preventDefaults the
     click and then *manually* sets window.location to /cart, there's not
     much we can do client-side. The above covers the standard cases. */

  /* ------------------------------------------------------------------ */
  /* Defensive close — delegated handlers so the X button + ESC + body  */
  /* underlay always close the drawer, even if the theme's constructor- */
  /* time listener got detached (e.g. after empty-cart re-render).      */
  /* ------------------------------------------------------------------ */
  function getOpenDrawer() {
    var d = document.querySelector('cart-drawer.is-open');
    if (d) return d;
    var anyDrawer = document.querySelector('cart-drawer');
    return anyDrawer && anyDrawer.classList.contains('is-open') ? anyDrawer : null;
  }

  function forceCloseDrawer(drawer) {
    if (!drawer) drawer = getOpenDrawer();
    if (!drawer) return false;
    if (!drawer.classList.contains('is-open')) return false;
    /* Prefer the theme's own method if it's still wired up. */
    if (typeof drawer.closeCartDrawer === 'function') {
      try { drawer.closeCartDrawer(); return true; } catch (e) { /* fall through */ }
    }
    /* Manual fallback that mirrors what theme.dev.js does. */
    drawer.classList.add('is-closing');
    drawer.classList.remove('is-open');
    if (typeof drawer.cartDrawerIsOpen !== 'undefined') drawer.cartDrawerIsOpen = false;
    document.dispatchEvent(new CustomEvent('theme:cart-drawer:close', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    setTimeout(function () { drawer.classList.remove('is-closing'); }, 600);
    return true;
  }

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest && e.target.closest('[data-cart-drawer-close]');
    if (closeBtn) {
      var drawer = closeBtn.closest('cart-drawer') || getOpenDrawer();
      if (drawer) {
        e.preventDefault();
        forceCloseDrawer(drawer);
      }
      return;
    }
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-drawer-underlay')) {
      forceCloseDrawer();
    }
  }, false);

  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape' && e.code !== 'Escape') return;
    forceCloseDrawer();
  });

  /* ------------------------------------------------------------------ */
  /* Add-to-cart silent retry — if a /cart/add form / quick-add submit  */
  /* doesn't actually mutate the cart within 800ms (e.g. <product-form> */
  /* hadn't upgraded yet on first visit), fire one direct fallback so   */
  /* the very first click never silently no-ops.                        */
  /* ------------------------------------------------------------------ */
  function readCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { return cart ? cart.item_count : null; })
      .catch(function () { return null; });
  }

  function fallbackAddFromForm(form) {
    if (!form) return Promise.resolve(null);
    var fd = new FormData(form);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (line) {
        if (!line) return null;
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        var anyDrawer = document.querySelector('cart-drawer');
        if (anyDrawer && typeof anyDrawer.openCartDrawer === 'function' && !anyDrawer.classList.contains('is-open')) {
          try { anyDrawer.openCartDrawer(); } catch (e) {}
        }
        return line;
      })
      .catch(function () { return null; });
  }

  /* Per-form cooldown so a click + native submit don't both schedule the
     same retry. */
  var addRetryCooldown = new WeakMap();
  function scheduleAddRetry(form) {
    if (!form) return;
    var now = Date.now();
    var last = addRetryCooldown.get(form) || 0;
    if (now - last < 1500) return;
    addRetryCooldown.set(form, now);
    readCartCount().then(function (beforeCount) {
      setTimeout(function () {
        readCartCount().then(function (afterCount) {
          if (afterCount == null) return;
          if (beforeCount == null || afterCount <= beforeCount) {
            fallbackAddFromForm(form);
          }
        });
      }, 800);
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!looksLikeCartAddForm(form)) return;
    scheduleAddRetry(form);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!looksLikeCartAddForm(form)) return;
    scheduleAddRetry(form);
  }, true);

  /* On drawer open we DON'T fetch (no cart change happened). Just re-bind
     UI handlers in case build() replaced inner HTML, and lazy-load recs. */
  document.addEventListener('theme:cart-drawer:open', function () {
    setTimeout(function () {
      var drawer = document.querySelector(SELECTORS.drawer);
      if (!drawer) return;
      bindTotalToggle(drawer);
      bindRecAdd(drawer);
      injectPillCustomSvgs(drawer.querySelector(SELECTORS.pills));
      bindPillApply(drawer);
      bindPillRemove(drawer);
      syncDrawerCartCounts(drawer);
      syncModernCartTotalDisplay(drawer);
      syncDrawerBreakdownMoney(drawer);
      normalizeDrawerLinePrices(drawer);
      armDrawerPriceGuard(drawer);
      ensureTotalToggleVisible(drawer);
      bindTotalToggleDelegation(drawer);
      loadRecommendations(drawer);
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      loadRecommendations();
    });
  } else {
    init();
    loadRecommendations();
  }
})();
